export const TEXT_404 = "404";
export const STYLE_NOT_FOUND = "Style Not Found";
export const NOT_FOUND_DESCRIPTION =
    "We took a detour on our style journey. Stay tuned for a fashionable comeback!";
export const GO_TO_HOMEPAGE = "GO BACK TO HOMEPAGE";
